/**
 * Message types are now schema-derived and read-only.
 * Delete functionality is no longer available.
 * This component is retained as a no-op for import compatibility.
 */
function MessageTypeDeleteModal() {
  return null;
}

export default MessageTypeDeleteModal;
